import styled from 'styled-components'

import { ModalBodyContainer } from 'components/modal/styled'

export const ModalBody = styled(ModalBodyContainer)`
  min-height: 200px;
  max-width: 420px;
  margin: ${({ theme }) => `${theme.spacings[6]} auto`};
`
